<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractPropertyTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="service_category"
                        arrows >
                    <template slot="gofixTab:service_category">
                        <b-row no-gutters class="heig-frame-child">
                            <b-col md="3" class="pr-15">
                                <gofix-card title="Service Category" class="mb-0 h-100 contractTree">
                                    <template slot="gofixCard:right_header">
                                        <gofix-button
                                            class="scontract-service-button"
                                            label="Save"
                                            :disabled="!$checkRole($accessModule.supplier_contract_service_category, 'update') || isAction"
                                            @click="save"
                                            :loading="isAction">
                                        </gofix-button>
                                    </template>
                                    <div class="contenAbsolute">
                                        <div class="tree-view-properties">
                                            <tree ref="tree" :data="treeData" @node:clicked="select" :options="opts">
                                                <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                            </tree>
                                        </div>
                                    </div>
                                </gofix-card>
                            </b-col>
                            <b-col md="9">
                                <gofix-card :title="breadCrumb" classHeader="mb-0" classContent="pt-33" class="mb-0 h-100">
                                    <b-row class="content">
                                        <b-col md="4">
                                            <gofix-text-field label="Parents" oneline>{{nodeInfo.parents}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-text-field label="Name" oneline>{{nodeInfo.name}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-text-field label="Abbrevation" oneline>{{nodeInfo.abbrevation}}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    const eventsList = [
        { name: 'node:checked', args: ['Node'] },
        { name: 'node:unchecked', args: ['Node'] },
    ]
    import { mapGetters } from 'vuex';
    import LiquorTree from 'liquor-tree'
    import splitPane from 'vue-splitpane'
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'supplier-service-category',
        components: {
            [LiquorTree.name]: LiquorTree,
            splitPane
        },
        data() {
            return {
                contract_tab:tabData.supplier_contract,
                treeData: this.getData(),
                isLoadNode: 1,
                opts: {
                    fetchData: (node) => {
                        // node.isBatch = false;
                        // return new Promise((resolve, reject) => {
                        //     resolve([]);
                        // });
                        if(node.children && node.children.length > 0) return Promise.resolve([]);
                        if(this.isLoadNode)
                            return new Promise((resolve, reject) => {
                                this.isLoadNode = 0
                                global.axios(`api/s-contracts/${this.$route.params.id}/tree-service-categories/${node.data.id}`, {
                                    method: "GET",
                                    headers: {
                                        Accept: "application/json",
                                    }
                                })
                                    .then(response => {
                                        this.isLoadNode = 1;
                                        response.data.data.map(item=>{
                                            if(item.state.checked==null || item.state.checked==false) {
                                                node.states.checked = false
                                            }
                                        })
                                        if(!node.parent) resolve([]); // if node haven't parent will reset array

                                        resolve(response.data.data);
                                    })
                                    .catch(error => reject(error));
                            });
                    },
                    checkbox: true,
                },
                filter_sor: JSON.parse(JSON.stringify(filters['s_sor'])),
                checkedTrueID: [],
                checkedID: [],
                checkedIDUpdate: [],
                removeID: [],
                isAction: false,
                nodeInfo : {
                    parents : '',
                    name : '',
                    abbrevation : ''
                },
                breadCrumb : '',
                removeNodes: [],
                timer: {
                    save: null
                }
            }
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            }
        },
        created() {},
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
            eventsList() {
                return this.events.concat().reverse()
            }
        },
        mounted() {
            eventsList.forEach(e => {
                this.$refs.tree.$on(e.name, this.initEventViewer(e))
            })
        },
        methods: {
            initEventViewer(event) {
                const goble = this;
                const events = this.events
                return function(node, newNode) {
                    let id = ''
                    let related_id = ''
                    let targetNode = newNode && newNode.data.text ? newNode : node

                    if (targetNode && targetNode.text) {

                        id = targetNode.id
                        related_id = targetNode.data.related_id
                    }
                    if (event.name == 'node:unchecked') {
                        if (node.states.expanded) {
                            return; 
                        }
                        if(!goble.removeID.includes(id)) {
                            goble.removeNodes.push({
                                data: targetNode.data,
                                children: targetNode.children,
                                parent: targetNode.parent,
                            })
                            goble.removeID.push(id);
                        }
                        // if ((!goble.removeID.includes(id) && goble.nodeTick == null) || (!goble.removeID.includes(id) && goble.nodeTick != null && goble.nodeTick.parent && goble.nodeTick.parent.id != id)) {
                        //     goble.removeID.push(id);
                        // }
                        if (goble.checkedIDUpdate.includes(id)) {
                            goble.checkedIDUpdate = goble.checkedIDUpdate.filter(e => e !== id)
                        }
                        goble.checkedID = goble.checkedID.filter(e => e.id !== id)
                    }
                    if (event.name == 'node:checked') {
                        goble.removeID = goble.removeID.filter(e => e !== id);
                        if (!goble.checkedIDUpdate.includes(id)) {
                            goble.checkedIDUpdate.push(id);
                        }
                        if (!goble.checkedID.includes(id)) {
                            goble.checkedID.push(id);
                        }

                    }

                    if((arguments[1]== undefined && arguments.length ==2) && event.name == 'node:checked'){
                        if (!goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID.push(id);
                        }
                    }
                    if((arguments[1]== undefined && arguments.length == 2) && event.name == 'node:unchecked'){
                        if (goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID = goble.checkedTrueID.filter(e => e !== id);
                        }
                    }
                    /*if (event.name == 'node:checked') {
                        goble.removeID = goble.removeID.filter(e => e !== id);
                        if (!goble.checkedIDUpdate.includes(id)) {
                            goble.checkedIDUpdate.push(id);
                        }
                        if (!goble.checkedID.includes(id)) {
                            goble.checkedID.push({
                                id: id,
                                related_id: related_id
                            });
                        }
                    }
                    if((arguments[1]== undefined && arguments.length ==2) && event.name == 'node:checked'){
                        if (!goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID.push(id);
                        }
                    }
                    if((arguments[1]== undefined && arguments.length == 2) && event.name == 'node:unchecked'){
                        if (goble.checkedTrueID.includes(id)) {
                            goble.checkedTrueID = goble.checkedTrueID.filter(e => e !== id);
                        }
                    }*/
                }
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(() => {
                    let parents = {};
                    for (let index = 0; index < this.removeNodes.length; index++) {
                        const item = this.removeNodes[index];
                        if(item.children.length > 0) {
                            parents[item.data.id] = item.children.map(node => node.data.id)
                        }
                    }

                    // Check each parent's children against removeID
                    for (const parentId in parents) {
                        const children = parents[parentId];
                        // Count how many children are in removeID
                        const childrenInRemoveIDCount = children.reduce((count, childId) => 
                            this.removeID.includes(childId) ? count + 1 : count, 0
                        );

                        if (childrenInRemoveIDCount == children.length) {
                            // Remove all children IDs and parent ID from removeID
                            this.removeID = this.removeID.filter(id => 
                                !children.includes(id) && id !== parentId
                            );
                        } else {
                            // If not all children are in removeID, remove the parent ID
                            if(childrenInRemoveIDCount > 0 &&parentId != this.rootId)
                                this.removeID = this.removeID.filter(id => id != parentId);
                        }
                    }

                    for (let i = 0; i < this.removeID.length; i++) {
                        const removeId = this.removeID[i];
                        const matchingNode = this.removeNodes.find(node => node.data.id === removeId);
                        
                        const checkParentRecursively = (node) => {
                            if (!node || !node.parent) return;
                            
                            const siblings = node.parent.children;
                            const allSiblingsUnchecked = siblings.every(sibling => 
                                sibling.states.checked === false || sibling.data.id === this.removeID[i]
                            );
                            
                            if (allSiblingsUnchecked) {
                                // Remove current node and its siblings from removeID
                                siblings.forEach(sibling => {
                                    const index = this.removeID.indexOf(sibling.data.id);
                                    if (index > -1) {
                                        this.removeID.splice(index, 1);
                                        if (index <= i) i--;
                                    }
                                });
                                
                                // Add parent ID if not already in removeID
                                if (!this.removeID.includes(node.parent.data.id)) {
                                    // Don't add root node if there are other nodes to remove
                                    if (this.removeID.length > 0 && !node.parent.parent) {
                                        return;
                                    }
                                    this.removeID.push(node.parent.data.id);
                                    // Continue checking the parent's level
                                    checkParentRecursively(node.parent);
                                }
                            }
                        };

                        if (matchingNode && matchingNode.parent) {
                            checkParentRecursively(matchingNode);
                        }
                    }

                    this.isAction = true;
                    const data = {
                        id: this.$route.params.id,
                        removeID: this.removeID,
                        dataID: this.checkedID,
                        checkedTrueID: this.checkedTrueID,
                        supplier_contract_id: this.$route.params.id
                    }
                    this.$store.dispatch('ServiveCategoryController/saveCheckedServiveCategory', data)
                        .then(result => {
                            this.checkedID = [];
                            this.removeID = [];
                            this.checkedTrueID = [];
                            this.isAction = false;
                            //Create vendor linking sor
                            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
                            //filter.is_maintenance.value = false;
                            delete filter.contract_term_id;
                            let params = {
                                contract_id: this.$route.params.id,
                                tickID: [],
                                untickID: [],
                                filter: filter,
                                isCMS: true
                            };
                            this.$store.dispatch("v2SorController/createVendorLinkingSOR",params);
                            this.$alertNotification(this.$notificationV2('editing', 'vendor_linking_service'));
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }, 300);
            },
            getData() {
                return new Promise(resolve => {
                    global.axios(`api/s-contracts/${this.$route.params.id}/tree-service-categories/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    }).then(response => {
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
                })
            },
            async select(node){
                if (!node.data.created_at) {
                    let ServiceCategoryInfo = await global.axios(`api/contracts/${this.$route.params.id}/service-categories/${node.data.id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    delete ServiceCategoryInfo.data.data.children;
                    delete ServiceCategoryInfo.data.data.data;
                    node.data = ServiceCategoryInfo.data.data
                }
                this.nodeInfo.parents = ''
                if(node.parent)
                    this.nodeInfo.parents = node.parent.data.text;
                this.nodeInfo.name = node.data.text;
                this.nodeInfo.abbrevation = node.data.abbreviation
                this.breadCrumb = node.data.breadcrumb + ' >> ' + node.data.name;
                if (!node.parent)
                    this.breadCrumb = node.data.name;
            }
        }
    }
</script>
